import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'mpro-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.scss']
})
export class DeleteModalComponent {
  faTimes = faTimes

  @Input() public title: string = `Confirm delete`;
  @Input() public titleDesc: string = '';
  @Input() public resourceName: string = '';
  @Input() public open: boolean = false;
  @Input() public actionBtn: string = 'Delete';
  @Output() public openChange: EventEmitter<boolean> = new EventEmitter();
  @Output() public onDelete: EventEmitter<void> = new EventEmitter();

  public get titleInfo(): string {
    return this.titleDesc ? this.titleDesc : `Are you sure you want to delete: ${this.resourceName}?`;
  }
}
